<template>
  <div>
    <div class="content">
      <span class="subtitle has-text-weight-bold has-text-info">
        Users
      </span>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Create Users
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="create"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Edit Users
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="edit"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Delete Users
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="remove"
            />
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'PermissionsUsersform',

  computed: {
    create: {
      get() {
        return this.$store.state.Permissions.permissions.admin.users.create;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_USERS_CREATE', value);
      },
    },

    edit: {
      get() {
        return this.$store.state.Permissions.permissions.admin.users.edit;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_USERS_EDIT', value);
      },
    },

    remove: {
      get() {
        return this.$store.state.Permissions.permissions.admin.users.delete;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_USERS_DELETE', value);
      },
    },
  },

};
</script>

<style lang="css" scoped>
</style>
